<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <h2>抱歉，本页面正在施工中，请耐心等待(›´ω`‹ )</h2>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
const title = "……"
const subtitle = "在写了在写了.jpg"
</script>
<style scoped>
h2{
    text-align: center;
    margin-bottom: 2rem;
}
</style>